import { createUseStyles } from 'react-jss'

import { transitionLong } from '../../../../styles/const/common'
import { backBtn } from '../../../../styles/common/components'
import { bottomDrawerPadding } from '../../../../styles/common/drawerForms'
import { hideVisibleScrollbar } from '../../../../styles/common'

const useStyles = createUseStyles({
  stepFormContainer: {
    overflowX: 'hidden',
    // sometimes before expanding container height scrollbar could be visible
    // also some unexpected bugs appear when scrollbar was visible but element didn't have height to scroll
    extend: hideVisibleScrollbar
  },
  form: {
    paddingBottom: bottomDrawerPadding
  },
  backBtn: {
    opacity: ({ activeStep }) => (activeStep === 0 ? 0 : 1),
    pointerEvents: ({ activeStep }) => (activeStep === 0 ? 'none' : 'auto'),
    extend: backBtn
  },
  steps: {
    display: 'flex',
    alignItems: 'flex-start',
    whiteSpace: 'nowrap',
    transition: transitionLong
  },
  stepItem: {
    whiteSpace: 'initial',
    minWidth: '100%',
    // edge of button on next step may be visible on previous step, padding 1px fixes it
    padding: '0 1px'
  }
})

export default useStyles
